import React from 'react';
import './FloatingCTA.css';

const PHONE = '+917087980024';
const WA_LINK = `https://wa.me/917087980024?text=${encodeURIComponent(
  'Hi CampusXL! I would like to know more about your programs. Shall we talk? Thank you!'
)}`;

const PhoneIcon = () => (
  <svg className="fcta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.45 2 2 0 0 1 3.59 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.83a16 16 0 0 0 6.29 6.29l1.42-1.42a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const ChatIcon = () => (
  <svg className="fcta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

// const ApplyIcon = () => (
//   <svg className="fcta-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//     <polyline points="14 2 14 8 20 8" />
//     <line x1="16" y1="13" x2="8" y2="13" />
//     <line x1="16" y1="17" x2="8" y2="17" />
//   </svg>
// );

const scrollToContact = (e) => {
  e.preventDefault();
  const section = document.getElementById('contact');
  if (!section) return;
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  window.scrollTo({ top: section.getBoundingClientRect().top + window.scrollY - headerHeight, behavior: 'smooth' });
};

const FloatingCTA = ({ onApplyNow }) => (
  <>
    {/* Apply Now side tab — desktop/tablet only */}
    {/* <button className="apply-tab" onClick={onApplyNow} aria-label="Apply Now">
      <span className="apply-tab__text">Apply Now</span>
      <svg className="apply-tab__arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 8h10M9 4l4 4-4 4" />
      </svg>
    </button> */}

    {/* Admission side tab */}
    <a href="#contact" className="admission-tab" onClick={scrollToContact} aria-label="Admission Open 2026-27">
      <span className="admission-tab__text">Admission Open 2026-27</span>
    </a>

    <div className="fcta-group">

      {/* Apply Now — mobile only (hidden on desktop via CSS) */}
      {/* <button
        className="fcta fcta--apply"
        onClick={onApplyNow}
        aria-label="Apply Now"
      >
        <ApplyIcon />
        <span className="fcta-label">Apply Now</span>
        <span className="fcta-mobile-label">Apply</span>
      </button> */}

      {/* Call CTA */}
      <a
        href={`tel:${PHONE}`}
        className="fcta fcta--call"
        aria-label="Talk to our representative"
      >
        <PhoneIcon />
        <span className="fcta-label">Talk To Us</span>
        <span className="fcta-mobile-label">Call</span>
      </a>

      {/* Chat / WhatsApp CTA */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noreferrer"
        className="fcta fcta--chat"
        aria-label="Connect to our Representative"
      >
        <ChatIcon />
        <span className="fcta-label">Chat With Us</span>
        <span className="fcta-mobile-label">Chat</span>
      </a>

    </div>
  </>
);

export default FloatingCTA;
